export default __webpack_public_path__ + "static/media/bolsa1verde.4f2b2317.svg";